import Vue from 'vue';

Vue.component('sales-category-index', () =>
    import(/* webpackChunkName: 'sales-category-index' */ './sales-category-index.vue'),
);

Vue.component('sales-category-index-es', () =>
    import(/* webpackChunkName: 'sales-category-index-es' */ './es-report/sales-category-index-es.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/sales-category/index.js